@if (combinedDeliveryInstallationData$ | async; as dataSet) {
  <app-delivery-report-table
    [ifs]="ifs"
    [columns]="columns"
    [dataSet]="dataSet"
    (openInstallationReportModal)="openInstallationReportModal($event)"
  ></app-delivery-report-table>
}
